import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JEService } from 'src/app/services/je-services.service';
import { ReportsService } from 'src/app/services/reports.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-vendor-subsidy-details',
  templateUrl: './vendor-subsidy-details.component.html',
  styleUrls: ['./vendor-subsidy-details.component.scss']
})
export class VendorSubsidyDetailsComponent implements OnInit {
  @ViewChild('miSurvey') miSurvey!: Table; // Correctly typed ViewChild
  @Output() mobilenumberEmit = new EventEmitter<string>();

  public subActionType: string = 'CompletedApps';
  public finYear: any;
  vendorCode: any;
  userType: any;
  public miTableData: any = [];
  public actionTypesFromTableData: any = [];
  public miCompletedFilterList: any = [];
  public subscriptions: any = [];
  public userId: any;
  public vendorRegId: any;
  public micada1Data: any = [];
  actionId: any = 18;
  public miTableDataWithFilter: any = [];
  public tableHeaderName = 'Subsidary Details';
  public miCompletedReport: MenuItem[] = [];
  public loading: boolean = false;
  public items: any[] = [];
  public selectedStatus: any;

  constructor(
    private reportsService: ReportsService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.finYear = 'All';
    this.loadSubsidaryDetails();

    this.miCompletedReport = [
      {
        label: 'Download Excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel();
        },
      },
      // You can add more export options here if needed
    ];
  }

  /**
   * Event handler for the search input.
   * @param event The input event.
   */
  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    this.applyFilter(value);
  }

  /**
   * Applies a global filter to the p-table based on the search input.
   * @param value The search string entered by the user.
   */
  applyFilter(value: string): void {
    if (this.miSurvey) {
      this.miSurvey.filterGlobal(value, 'contains');
    }
  }

  /**
   * Exports the current table data to an Excel file.
   * If a global filter is applied, exports only the filtered data.
   */
  exportExcel(): void {
    // Get the filtered data if a filter is applied; otherwise, use all data
    const modelData = this.miSurvey?.filteredValue || this.micada1Data || [];

    if (!modelData.length) {
      this.messageService.add({
        severity: 'info',
        summary: 'No Data',
        detail: 'No data available to export.',
      });
      return;
    }

    import('xlsx').then((xlsx) => {
      const dataToSave = modelData.map((d: any) => ({
        'APP ID': d.AppID,
        'Program Name': d.Program_Name,
        Amt: d.Amt,
        'Farmer Name': d.FarmerName,
        'Vendor Name': d.VendorName,
        District: d.District,
        Block: d.Block,
        Village: d.Village,
        PlantSpacing: d.PlantSpacing,
        RowSpacing: d.RowSpacing,
        MIArea: d.MIArea,
      }));

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      this.saveAsExcelFile(excelBuffer, `MI_${this.tableHeaderName}`);
    }).catch((error) => {
      console.error('Error importing xlsx:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Export Error',
        detail: 'An error occurred while exporting the data.',
      });
    });
  }

  /**
   * Saves the Excel file to the user's device.
   * @param buffer The binary data of the Excel file.
   * @param fileName The desired name of the Excel file.
   */
  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }

  /**
   * Loads subsidary details from the backend service.
   * Handles loading state, success, and error scenarios.
   */
  loadSubsidaryDetails(): void {
    const tokenString = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    if (!tokenString) {
      this.messageService.add({
        severity: 'error',
        summary: 'Authentication Error',
        detail: 'No authentication token found.',
      });
      return;
    }

    let token: any;
    try {
      token = JSON.parse(tokenString);
    } catch (error) {
      console.error('Error parsing token:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Authentication Error',
        detail: 'Invalid authentication token format.',
      });
      return;
    }

    let payload: any = {};
    try {
      const payloadBase64 = token?.authToken?.split('.')[1];
      if (payloadBase64) {
        const decodedPayload = atob(payloadBase64);
        payload = JSON.parse(decodedPayload);
      } else {
        throw new Error('Invalid token structure.');
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Authentication Error',
        detail: 'Failed to decode authentication token.',
      });
      return;
    }

    this.userId = payload?.sub;
    this.vendorRegId = token?.officeCode; // Assuming officeCode is not an object


    // Fetch subsidary details for status
    this.deptDashBoardService
      .GetVendorSubsidaryDetails(this.vendorRegId,'Vendor')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values || data; // Adjust based on actual data structure
          this.selectedStatus = this.items[0]?.status;
        },
        error: (err) => {
          console.error('Error loading status master:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Status Master can\'t be loaded.',
          });
        },
      });

    // Fetch subsidary details for table data
    this.loader.start();
    this.deptDashBoardService
      .GetVendorSubsidaryDetails(this.vendorRegId,'Vendor')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(
            this.userId,
            'MI Source Location',
            '',
            new Date(),
            'Success'
          );

          if (Array.isArray(data) && data.length > 0) {
            this.micada1Data = data;
          } else {
            this.micada1Data = [];
            this.messageService.add({
              severity: 'info',
              summary: 'No Data',
              detail: 'Data Not Found.',
            });
          }
        },
        error: (err) => {
          this.micada1Data = [];
          this.loader.close();
          this.activityRecordService.activityRecord(
            this.userId,
            'MI Source Location',
            '',
            new Date(),
            err
          );

          console.error('Error fetching subsidary details:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.message || 'An unexpected error occurred.',
          });
        },
      });
  }

  /**
   * Captures the filtered data from the table.
   * This method is optional if you decide to use a separate variable for filtered data.
   * @param event The filter event from the p-table.
   */
  onTableFilter(event: any): void {
    this.miTableDataWithFilter = event.filteredValue;
  }
}
